export default __webpack_public_path__ + "static/media/Asset 1@4x 2.58bf0899.png";